export class ShipmentEditModel {
}
